(function (angular) {
  "use strict";

  angular.module('myApp').component('catalougeContactUs', {
    templateUrl: '/catalougeContactUs/catalougeContactUs.tpl.html',
    controller: [
      '$scope', '$http', 'aimSave', 'contactUsService',
      function ($scope, $http, aimSave, contactUsService) {

        $scope.aim = new aimSave();
        $scope.aim.dto.country = "United States";


        // Select 2 Script
        //setTimeout(function () {
          
        //  $("#countries").select2({
        //    templateSelection: formatState,
        //    templateResult: formatState
        //  });
        //}, 200);

        $scope.submit = function () {
          contactUsService.save($scope.aim.dto).then(function (resp) {
            $scope.aim.result = resp.data;
            var fileUrl = $("#catalogeLink").val();
            var type = $("#type").val();
            var fileName = $("#fileName").val();
            if ($scope.aim.result.success == true) {
              if (fileUrl != "" || fileUrl != null) {
                $("#DownloadInquiryModel").modal('hide');
                $("#catalogeLink").val('');
                $scope.aim.result.message = '';
                if (type === "Download") {
                  var link = document.createElement('a');
                  link.href = fileUrl;
                  link.download = fileName !== '' ? fileName : "Wintel Surface Catalouge";
                  link.dispatchEvent(new MouseEvent('click'));
                } else {
                  window.open(window.location.origin + '/' + fileUrl, '_blank');
                }
              }
            }
          });
        }
      }
    ],
  });

}(window.angular));
